import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-rastercoords';
import 'leaflet-easybutton/src/easy-button.css';
import 'leaflet-easybutton';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';

export const VehicleDetectionImage = ({
	drawnLayers,
	setDrawnLayers,
	drawnLayersRef
}) => {
	const mapRef = useRef(null);
	const originalLayerRef = useRef(new L.FeatureGroup());
   

	let paintMode = false;
	var myPolyline;
    let eraseMode = false;
    const eraseRadiusMeters = 20; // Eraser radius

	useEffect(() => {
		if (!mapRef.current) {
			let layerCount = 1;

			const map = L.map('vehicleDetectionMap', {
				zoomControl: false,
				center: [50, -0.1],
				zoom: 13
			});

			mapRef.current = map;

			L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				lang: 'en',
				opacity: 1
			}).addTo(map);

			const drawControl = new L.Control.Draw({
				edit: {
					featureGroup: originalLayerRef.current,
					edit: true,
					remove: true
				},
				draw: {
					polygon: true,
					marker: true,
					polyline: true,
					circle: true,
					rectangle: true,
					circlemarker: true
				}
			});
			mapRef.current.addControl(drawControl);

			mapRef.current.on(L.Draw.Event.CREATED, function (e) {
				const layer = e.layer; // This is the drawn shape

				// Convert the drawn layer to GeoJSON
				const geojson = layer.toGeoJSON();
				geojson.name = 'Hello';
				geojson.id = layerCount;
				layerCount++;
				console.log('Drawn layer as GeoJSON:', geojson);
				e.layer.addTo(mapRef.current);
				console.log(e.layer);
				drawnLayers.push(geojson);
				drawnLayersRef.current.push(geojson);
				setDrawnLayers((prevItems) => [...prevItems, geojson]);
			});

			mapRef.current.on('click', function () {
				paintMode = !paintMode;
				if (paintMode) {
					myPolyline = L.polyline([], {
						color: 'blue', // stroke color
						weight: 30, // stroke width in pixels
						opacity: 0.1 // line transparency

						//dashArray: '5, 5'  // dashed line style (optional)
					}).addTo(mapRef.current);

					const geoJsonRoute = {
						type: 'Feature',
						id: layerCount,
						properties: {},
						geometry: {
							type: 'LineString',
							coordinates: myPolyline.editing.latlngs
						}
					};

                    if (myPolyline.editing.latlngs.length > 0) {
                        drawnLayersRef.current.push(geoJsonRoute);
                    

					layerCount++;
                    }

                    setDrawnLayers((prevItems) => [...prevItems, geoJsonRoute]);
					
				}
			});

			mapRef.current.on('mousemove', function (e) {
				if (paintMode) {
					myPolyline.addLatLng(e.latlng);
				}
			});
		}

		return () => {
			if (mapRef.current) {
				mapRef.current.remove();
				mapRef.current = null;
			}
		};
	}, []);

	console.log(originalLayerRef.current);

	return (
		<div
			id="vehicleDetectionMap"
			style={{ height: '100%', width: '100%' }}
		></div>
	);
};
